import { getEditorStateFromJSON } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { isProsemirrorRawContent } from '../../../prosemirror/protected/operators';
export const getEditorStateFromRawContent = rawContent => {
  if (!rawContent || !isProsemirrorRawContent(rawContent)) {
    return null;
  }
  return getEditorStateFromJSON(rawContent);
};